import { Controller, useFormContext } from 'react-hook-form'

import NumberField from 'modules/core/components/NumberField'
import i18n from 'modules/core/lib/i18n'

import { castError } from '../../castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from '../../withCustomizationFields'
import withFieldPermissions, { WithFieldPermissionsProps } from '../../withFieldPermissions'

const FIELD_NAME = 'reimbursableAmount'
interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  loadingExchangeRate: boolean
}

const ReimbursableAmountField = ({ isFieldReadOnly, loadingExchangeRate }: Props) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext()

  const { reimbursableCurrency } = watch()

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <NumberField
          label={i18n.t('expenses_v2.forms.fields.reimbursable_amount.label')}
          value={field.value}
          indicator={reimbursableCurrency}
          placeholder={'0'}
          maxDecimals={2}
          onChange={(value) => field.onChange(value ?? 0)}
          loading={loadingExchangeRate}
          error={castError(errors?.reimbursableAmount)}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(ReimbursableAmountField, FIELD_NAME))
